<template>
  <article class="wagb-blog wagb-blog--list">
    <div class="wagb-blog__grid">
      <article v-for="post in posts" :key="post.slug" class="wagb-blog__ui-card">
        <router-link :to="post.path" class="wagb-blog__card-cover wagb-blog__figure--photo">
          <img
            :src="post.image"
            :alt="post.imageAlt"
            width="640"
            height="360"
            loading="lazy"
          />
        </router-link>
        <div class="wagb-blog__card-body">
          <router-link :to="post.path" class="wagb-blog__card-title-link">
            <h2 class="wagb-blog__card-title">{{ post.listTitle }}</h2>
          </router-link>
          <p class="wagb-blog__card-desc">{{ post.description }}</p>
          <div class="wagb-blog__card-meta">
            <time class="wagb-blog__card-date" :datetime="post.date">{{ post.date }}</time>
            <router-link :to="post.path" class="wagb-blog__card-link">
              Read More
              <span class="wagb-blog__card-link-arrow" aria-hidden="true">→</span>
            </router-link>
          </div>
        </div>
      </article>
    </div>
  </article>
</template>

<script>
import '@/css/wagbappro-blog.scss';
import { blogPosts } from '@/data/wagbappro/blog-id';

export default {
  name: 'BlogListContent',
  data() {
    return { posts: blogPosts };
  },
};
</script>
